import { getContentPage } from '@/shared/api/generated/api';

import { ABOUT_CONTACTS_SEO } from '../model/constants';

import type { AboutContentPageData, AboutSeo } from '../model/types';

const getContentPageSeo = (slug: string, title: string): AboutSeo => {
  if (slug === 'contacts') {
    return ABOUT_CONTACTS_SEO;
  }

  return {
    title,
  };
};

export const getAboutContentPage = async (slug: string): Promise<AboutContentPageData> => {
  const response = await getContentPage({
    path: {
      slug,
    },
  });

  const page = response.data;

  if (!page) {
    throw new Error(`Content page "${slug}" response is empty`);
  }

  const title = page.name_ru;

  return {
    slug,
    title,
    html: page.text_ru,
    seo: getContentPageSeo(slug, title),
  };
};
